export class AppError extends Error {
  constructor(message: string) {
    super(`[APP]${message}`);
    Object.setPrototypeOf(this, AppError.prototype);
  }
}

export class AppWrappedError extends AppError {
  constructor(msg: string, public subError: Error) {
    super(`${msg}\n  > ${subError.message}`);
    Object.setPrototypeOf(this, AppWrappedError.prototype);
  }
}

export class AppInvariantError extends AppError {
  constructor(msg: string) {
    super(`[INVARIANT]: ${msg}`);
    Object.setPrototypeOf(this, AppInvariantError.prototype);
  }
}

export class WrappedError extends AppError {
  constructor(errorType: string, msg: string, public subError: Error) {
    super(`[${errorType}]: ${msg}`);
    Object.setPrototypeOf(this, WrappedError.prototype);
  }
}

export class AppMapperError extends WrappedError {
  constructor(mapperName: string, public subError: Error) {
    super('MAPPER', `Error in ${mapperName} mapper`, subError);
    Object.setPrototypeOf(this, AppMapperError.prototype);
  }
}



// WEBPACK FOOTER //
// ./src/module/Common/error/index.ts